// extracted by mini-css-extract-plugin
module.exports = {"categoryLink":"shop-banner_categoryLink_1_Kec","closedBanner":"shop-banner_closedBanner_bRHXM","saleBanner":"shop-banner_saleBanner_y-XjX"};